import React, { useEffect } from 'react';
import { useCurrentRoute as useCurrentRouteDI } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import {
	useAnalyticsEvents as useAnalyticsEventsDI,
	fireScreenAnalytics as fireScreenAnalyticsDI,
} from '@atlassian/jira-product-analytics-bridge';
import { isNinGlobalScopeEnrolmentEnabledResource } from '@atlassian/jira-router-resources-is-nin-global-scope-enrolment-enabled/src/index.tsx';

import {
	Redirect as RedirectDI,
	useResource,
	useQueryParam as useQueryParamDI,
} from '@atlassian/react-resource-router';

import { fg } from '@atlassian/jira-feature-gating';
import type { QuickSearchToGlobalIssueNavigatorRedirectProps } from './types.tsx';

export const QuickSearchToGlobalIssueNavigatorRedirect = ({
	Redirect = RedirectDI,
	fireScreenAnalytics = fireScreenAnalyticsDI,

	useAnalyticsEvents = useAnalyticsEventsDI,

	useCurrentRoute = useCurrentRouteDI,

	useQueryParam = useQueryParamDI,
}: QuickSearchToGlobalIssueNavigatorRedirectProps): React.JSX.Element => {
	const route = useCurrentRoute();

	const [searchString] = useQueryParam('searchString');

	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { data: isNinEnabled } = useResource(isNinGlobalScopeEnrolmentEnabledResource);

	// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
	useEffect(() => {
		if (!route) return;

		const screenEvent = createAnalyticsEvent({
			screenName: 'quickSearchRedirect',
			attributes: {
				type: route.name,
			},
		});
		fireScreenAnalytics(screenEvent);
	}, [createAnalyticsEvent, fireScreenAnalytics, route]);

	let jql: string;
	if (isNinEnabled || fg('nin_remove_global_scope_enrolment')) {
		jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
	} else {
		jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
	}

	const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;

	return <Redirect to={redirectUrl} />;
};

const JiraGlobalIssueNavigatorRedirect = (): React.JSX.Element => (
	<QuickSearchToGlobalIssueNavigatorRedirect />
);

export default JiraGlobalIssueNavigatorRedirect;
